import React from 'react';
import GlassCard from './GlassCard';

// Spec §14 Panel — GlassCard with a bordered header row and a padded body.
const Panel = ({ title, action, children, bodyClassName = '', className = '' }) => {
  return (
    <GlassCard className={`overflow-hidden p-0 ${className}`}>
      {title && (
        <div className="flex items-center justify-between gap-2 px-4 py-3 border-b border-headerBorder">
          <h2 className="text-textPrimary font-semibold" style={{ fontSize: '0.875rem' }}>
            {title}
          </h2>
          {action}
        </div>
      )}
      <div className={`p-4 ${bodyClassName}`}>{children}</div>
    </GlassCard>
  );
};

export default Panel;
